import React from 'react';
import {Button, message, Popconfirm} from "antd";
import {DeleteOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {useDeleteDriverByIdMutation, useGetDriverQuery} from "../../../slices/rootApiSlices/driverApiSlice";

const DeleteVehicle = ({id}) => {

    const navigate = useNavigate();
    const {user} = useSelector(state => state.auth);
    const {refetch} = useGetDriverQuery(user?.token)
    const [deleteHandle, isLoading] = useDeleteDriverByIdMutation();


    const handleDelete = async () => {
        try {
            await deleteHandle({token: user?.token, id}).unwrap();
            navigate('/settings/drivers');
            refetch();
            message.success('İşlem başarılı')
        } catch (e) {
            message.error('İşlem başaarısız lütfen tekrar deneyiniz.')
            navigate('/settings/drivers');
        }
    }

    const cancel = () => {
        message.warning('İşlemden vazgeçildi.');
    };


    return (
        <Popconfirm
            title="Sürücüyü silmek istediğinize emin misiniz ?"
            onConfirm={handleDelete}
            onCancel={cancel}
            okText="Sil"
            cancelText="Vazgeç"
        >
            <Button loading={isLoading} style={{marginLeft: 3}} type="primary" danger icon={<DeleteOutlined/>}>
                Sil
            </Button>
        </Popconfirm>
    );
};

export default DeleteVehicle;
